import {
  MDBBtn,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
} from "mdbreact";
import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  showHideLoader,
  showNotification,
  toggleModal,
} from "../../../../actions";
import {
  deleteMemberPhoto,
  getMemberPhoto,
  uploadMemberPhoto,
} from "../../../../apis/MemberPhotoApi";
import { useState } from "react";
import { custom, confirm as DevExtremeConfirm } from "devextreme/ui/dialog";

const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3MB
const MIN_WIDTH = 300;
const MIN_HEIGHT = 300;
const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];

function MemberPhotoModal({ showModal, onClose, customerId, role }) {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("/images/No_Image_Available.jpg");
  const [isUser, setIsUser] = useState(false);

  useEffect(() => {
    if (!showModal) return;
    if (role && role.role === "User") {
      setIsUser(true);
    }
    dispatch(showHideLoader(true));

    getMemberPhoto(customerId).then((res) => {
      if (!res.data) return;
      const metadata = res.data.data;

      if (
        metadata &&
        metadata.presigned_url !== null &&
        metadata.presigned_url !== undefined
      ) {
        setPreview(metadata.presigned_url);
      }
    });
    dispatch(showHideLoader(false));
  }, [showModal]);

  const handleClose = () => {
    setError(null);
    setPreview("/images/No_Image_Available.jpg");
    dispatch(toggleModal({ isOpen: false }));
    onClose();
  };
  const handleOnSubmit = async (e) => {
    if (isUser) return;

    e.preventDefault();
    if (!file) {
      setError("File must not be empty");
      return;
    }
    try {
      await validateImage(file);
      setSubmitting(true);
      dispatch(showHideLoader(true));

      uploadMemberPhoto(customerId, file).then((response) => {
        if (response.status && response.status >= 400) {
          setError(response.data.message);
        } else {
          if (!response.data) return;
          const metadata = response.data.data;
          if (metadata.presigned_url) {
            setPreview(metadata.presigned_url);
          }
        }
      });
      setFile(null);
      dispatch(
        showNotification("success", "Successfully uploaded member photo"),
      );
      dispatch(showHideLoader(false));
    } catch (error) {
      setError(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleFileOnChange = async (e) => {
    if (isUser) return;

    if (!e.target.files) return;
    dispatch(showHideLoader(true));

    const file = e.target.files[0];
    setFile(file);
    setError(null);
    setPreview(URL.createObjectURL(file));

    try {
      await validateImage(file);
      setSubmitting(false);
    } catch (error) {
      setError(error);
      setSubmitting(true);
    } finally {
      dispatch(showHideLoader(false));
    }
  };

  const handleOnRemoveProfile = () => {
    if (isUser) return;
    let result = DevExtremeConfirm(
      `Are you sure you want to remove the profile photo of <b>${customerId ? customerId + " Member" : "Member"}</b>?`,
    );

    result.then(async (dialogResult) => {
      if (dialogResult) {
        dispatch(showHideLoader(true));
        setSubmitting(true);
        try {
          let response = await deleteMemberPhoto(customerId);
          if (response.status && response.status >= 400) {
            setError(response.data.message);
          } else {
            dispatch(showNotification("success", response.data.message));
            setError(null);
            setFile(file);
          }
          setPreview("/images/No_Image_Available.jpg");
        } catch (err) {
          dispatch(showNotification("error", err.data.message));
        } finally {
          dispatch(showHideLoader(false));
          setSubmitting(false);
        }
      }
    });
  };
  const validateImage = (file) => {
    if (isUser) return;

    return new Promise((resolve, reject) => {
      // 1️⃣ Type check
      if (!ALLOWED_TYPES.includes(file.type)) {
        return reject("Only JPEG, PNG, or WebP images are allowed.");
      }

      // 2️⃣ Size check
      if (file.size > MAX_FILE_SIZE) {
        return reject("Max file size is 3MB.");
      }

      // 3️⃣ Dimension check
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        const { width, height } = img;

        URL.revokeObjectURL(objectUrl);

        if (width < MIN_WIDTH || height < MIN_HEIGHT) {
          return reject(`Minimum dimensions are ${MIN_WIDTH}x${MIN_HEIGHT}px.`);
        }

        resolve();
      };

      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject("Invalid image file.");
      };

      img.src = objectUrl;
    });
  };
  return (
    <div className="child-popup">
      <MDBModal size="lg" isOpen={showModal} toggle={() => handleClose()}>
        <MDBModalHeader>
          {isUser ? "Profile Photo" : "Member Profile Photo"}
        </MDBModalHeader>
        <form id="uploadPhoto" onSubmit={handleOnSubmit}>
          <MDBModalBody>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "300px",
                textAlign: "center",
              }}
            >
              <img
                src={preview}
                alt="Profile"
                style={{ width: 512, height: 512, objectFit: "cover" }}
              />
              {error && <p style={{ color: "red" }}>{error}</p>}
              {!isUser && (
                <MDBInput
                  type="file"
                  onChange={(e) => {
                    handleFileOnChange(e);
                  }}
                />
              )}
            </div>
          </MDBModalBody>
        </form>
        <MDBModalFooter>
          {!isUser && (
            <>
              <MDBBtn
                type="submit"
                form="uploadPhoto"
                disabled={submitting}
                color="primary"
              >
                Submit
              </MDBBtn>
              <MDBBtn
                type="submit"
                disabled={submitting}
                color="danger"
                onClick={() => handleOnRemoveProfile()}
              >
                Remove
              </MDBBtn>
            </>
          )}

          <MDBBtn color="secondary" onClick={() => handleClose()}>
            Close
          </MDBBtn>
        </MDBModalFooter>
      </MDBModal>
    </div>
  );
}
export default MemberPhotoModal;
